import React, { useState } from 'react';
import MensurationalHistory from './MensurationalHistory';
import SexualHistory from './SexualHistory';
import PreviousObstetricHistory from './PreviousObstetricHistory';
import {
  renderCheckboxes,
  renderDropdown,
  renderInputField,
} from '../../../common/inputField';
import TreatmentHistory from './TreatmentHistory';
import PreviousIVF from './PreviousIVF';
import { useDispatch, useSelector } from 'react-redux';
import {
  deletePatientUploadedFiles,
  setPatientData,
  setPatientUploadedFiles,
} from '../../../actions';
import { CustomTextArea } from '../../../common/CustomTextArea';
import CustomSelectField from '../../../common/CustomSelectField';
import FileUploadCard from '../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../components/FileManager/FileDocumentCard';
import { toast } from 'sonner';
import {
  checkFileAvailabilityApi,
  createPatientHistoryPdfApi,
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { useParams } from 'react-router-dom';
import { deleteFileApi } from '../../../api/fileApi';
import { downloadFile, pollFileAvailability } from '../../../api/utils';

const PatientHistory = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`patientHistory.${name}`, value));
  };

  const handleFamilyHistoryChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes = patientData.patientHistory.familyHistory.map(
      (item, idx) => (idx === index ? { ...item, checked } : item),
    );

    if (name === 'otherValue') {
      dispatch(
        setPatientData('patientHistory.familyHistoryOther', e.target.value),
      );
    } else {
      dispatch(
        setPatientData(`patientHistory.familyHistory`, updatedCheckboxes),
      );
    }
  };

  const handleGeneralHistoryChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes = patientData.patientHistory.generalHistory.map(
      (item, idx) => (idx === index ? { ...item, checked } : item),
    );

    if (name === 'otherValue') {
      dispatch(
        setPatientData('patientHistory.generalHistoryOther', e.target.value),
      );
    } else {
      dispatch(
        setPatientData(`patientHistory.generalHistory`, updatedCheckboxes),
      );
    }
  };

  const handlePastHistoryInputChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes = patientData.patientHistory.pastMedicalHistory.map(
      (item, idx) => (idx === index ? { ...item, checked } : item),
    );

    if (name === 'otherValue') {
      dispatch(
        setPatientData(
          'patientHistory.pastMedicalHistoryOther',
          e.target.value,
        ),
      );
    } else {
      dispatch(
        setPatientData(`patientHistory.pastMedicalHistory`, updatedCheckboxes),
      );
    }
  };
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [uploadedFiles, setUploadedFiles] = useState([]);
  const uploadedFiles = useSelector(
    (state) => state.clinicalReducer.uploadedFiles,
  );
  const setUploadedFiles = (files) => {
    dispatch(setPatientUploadedFiles(files));
  };
  const [loadingText, setLoadingText] = useState('');
  const { id: patientId } = useParams();

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            'PatientHistory',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles({ file: data, fileTag: 'PatientHistory' });
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        setLoading(false);
        setLoadingText('');
        toast.error('Failed to upload file');
      }
    });
  };
  const handleDeleteFile = async (file) => {
    try {
      console.log('File to delete:', file);
      await deleteFileApi('patient', patientId, file.id);
      dispatch(deletePatientUploadedFiles(file));
      toast.success('File deleted successfully');
    } catch (err) {
      console.log('err', err);
      toast.error('Error deleting file');
    }
  };

  const handleSheetDownload = async () => {
    try {
      const response = await createPatientHistoryPdfApi(patientId);
      toast.success('patient history will be downloaded shortly');
      const bucketName = response.data.pdf.output_bucket_name;
      const key = response.data.pdf.output_key;
      try {
        const presignedUrl = await pollFileAvailability(
          checkFileAvailabilityApi,
          bucketName,
          key,
        );
        downloadFile(presignedUrl, patientId);
      } catch (error) {
        console.error('Failed to get presigned URL:', error);
      }
    } catch (error) {
      console.error('Failed to download OPU sheet:', error);
    }
  };
  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <div className="card">
          <div className="header">
            <p className="lead">PATIENT HISTORY</p>
          </div>
          <div className="body">
            <div className="card_name_container col-md-8">
              {renderInputField(
                'Duration of marriage (years)',
                'durationOfMarriage',
                patientData.patientHistory.durationOfMarriage,
                handleInputChange,
                false,
                '',
                false,
                true,
              )}

              {renderInputField(
                'Duration of attempting pregnancy (years)',
                'durationOfPregnancyAttempts',
                patientData.patientHistory.durationOfPregnancyAttempts,
                handleInputChange,
                false,
                '',
                false,
                true,
              )}
            </div>

            <MensurationalHistory />

            <SexualHistory />

            <PreviousObstetricHistory />

            <div className="form-group">
              <div className="header">
                <p className="lead">PREVIOUS SURGERIES</p>
              </div>
              <div className="input-group mb-3">
                <CustomTextArea
                  value={patientData.patientHistory.previousSurgeries}
                  onChange={handleInputChange}
                  name="previousSurgeries"
                  placeholder="Previous Surgeries"
                />
              </div>
              {/* <CustomSelectField
                label="PAST MEDICAL HISTORY"
                name="pastMedicalHistory"
                value={patientData.patientHistory.pastMedicalHistory}
                options={[
                  'Allergies',
                  'DM',
                  'HTn',
                  'Thyroid',
                  'Asthma',
                  'Tuberculosis',
                ]}
                otherValue={patientData.patientHistory.pastMedicalHistoryOther}
                onChange={handleInputChange}
                isOtherValue={true}
              /> */}

              <div className="card_name_container">
                {renderCheckboxes(
                  patientData.patientHistory.pastMedicalHistory,
                  handlePastHistoryInputChange,
                  'PAST MEDICAL HISTORY',
                  'pastMedicalHistory',
                  patientData.patientHistory.pastMedicalHistoryOther,
                )}
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="body">
              <div className="">
                <label className="input-group-text">FAMILY HISTORY</label>
                {renderCheckboxes(
                  patientData.patientHistory.familyHistory,
                  handleFamilyHistoryChange,
                  '',
                  'familyHistory',
                  patientData.patientHistory.familyHistoryOther,
                )}
              </div>

              <div>
                <label className="input-group-text">GENERAL HISTORY</label>
                {renderCheckboxes(
                  patientData.patientHistory.generalHistory,
                  handleGeneralHistoryChange,
                  '',
                  'generalHistory',
                  patientData.patientHistory.generalHistoryOther,
                )}
              </div>
            </div>
          </div>

          <TreatmentHistory />
          <PreviousIVF />
          <div style={{ paddingTop: '50px' }}>
            <div className="row clearfix">
              <FileUploadCard
                setFiles={setFiles}
                setUploadedFiles={setUploadedFiles}
                files={uploadedFiles}
                handleUpload={handleUpload}
                id={patientId}
              />
              {uploadedFiles.map((uploadedFile, i) => {
                const data = uploadedFile.file;
                if (uploadedFile.fileTag !== 'PatientHistory') return null;
                return (
                  <FileDocumentCard
                    key={i}
                    DocumentName={data.displayFileName}
                    DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                    DocumentDate={new Date(data.updatedAt).toLocaleDateString()}
                    ImageUrl={
                      data?.fileType?.includes('image')
                        ? data.presignedUrl
                        : undefined
                    }
                    handleDeleteFile={() => handleDeleteFile(data)}
                    file={data}
                    fileUniquePrefix={`patient-${patientId}`}
                  />
                );
              })}
            </div>
          </div>
          <div
            style={{
              width: '100%',
              mb: 2,
              justifyContent: 'center',
              display: 'flex',
              marginBottom: 20,
            }}
          >
            <button
              className="btn btn-primary"
              style={{ margin: '10px 10px 0px 0px' }}
              onClick={handleSheetDownload}
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientHistory;
